export default class MakersDomain {
    constructor(domain, storage) {
      this.domain = domain;
      this.storage = storage;
    }
}